import {RecurringStripePrice} from 'src/features/pricing/types';

export const isRecurringStripePrice = (price: {
  // to adjust for the new Stripe data model
  type: unknown;
}): price is RecurringStripePrice => {
  return price.type === 'recurring';
};
